import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'remixicon/fonts/remixicon.css';

import App from './App';
import { getCsrfToken } from './api/csrf';
import { createRuntimeApiRegistry } from './api/create-runtime-api';
import { createUnauthorizedBridge } from './api/session';
import { runtimeConfig } from './config/runtime';
import { applyTheme, getInitialTheme } from './hooks/useTheme';
import './index.css';

applyTheme(getInitialTheme());

const unauthorizedBridge = createUnauthorizedBridge();
void start();

async function start() {
  const registry = await createRuntimeApiRegistry(
    runtimeConfig.apiMode === 'mock'
      ? { mode: 'mock' }
      : {
          mode: 'backend',
          backend: {
            baseUrl: requireBackendBaseUrl(),
            csrfToken: getCsrfToken,
            unauthorized: unauthorizedBridge.transport,
          },
        },
  );

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App registry={registry} unauthorizedBridge={unauthorizedBridge} />
    </StrictMode>,
  );
}

function requireBackendBaseUrl(): string {
  if (!runtimeConfig.apiBaseUrl) {
    throw new Error('Backend API URL is unavailable');
  }
  return runtimeConfig.apiBaseUrl;
}
